import { inject, injectable, singleton } from "tsyringe";
import { Api, ApiError } from "./Api";

@injectable()
export class UserService
{
    protected api: Api;

    protected _user: any;

    public get user(): any
    {
        return this._user;
    }

    constructor(@inject(Api) api: Api) 
    {
        this.api = api;
    }

    /**
     * Login + Set notification token
     */
    public async login(ic: string, pin: string, remember: boolean = false, notificationToken: string): Promise<any> {
        let response: any = null;
        const isEnabledTwoFormFactorAuth = process.env.VUE_APP_2FA_ENABLED == 1;
        try {
            response = await this.api.post('/login', {
                username: ic,
                password: pin,
                remember: remember
            });

            // force login, if two form factor auth is off
            if (isEnabledTwoFormFactorAuth === false) {
                // add token after login
                this.api.token = response.token;
                window.localStorage.setItem('token', this.api.token);
                this._user = response;

                // send notification token
                if (notificationToken) {
                    await this.api.post('/set-notification-token', {
                        notificationToken: notificationToken
                    })
                }
            }

        } catch (e) {
        }
        return {
            userId: response?.userId || null,
            verificationNumber: response?.verificationNumber || null,
            remember: remember,
            notificationToken: notificationToken
        };
    }

    /**
     * Verify number
     * @param id
     * @param code
     * @param remember
     */
    public async verify(id: string, code: string, remember: boolean): Promise<any>
    {

        let identity: any = null;
        try {
            identity = await this.api.post('/verify', {
                userId: id,
                code: code,
                remember: remember
            });

            console.log(identity,"identity");

            // add token after login
            this.api.token = identity.token;
            window.localStorage.setItem('token', this.api.token);
            this._user = identity;

        }
        catch(e) { }
        return {
            result: identity ? true : false,
            identity: identity
        };
    }

    public async logout(): Promise<void>
    {
        await this.api.get('/logout');
        this.api.token = null;
        this._user = null;
    }
}